import { render, staticRenderFns } from "./ChartsPage.vue?vue&type=template&id=4da6c1b0&"
import script from "./ChartsPage.vue?vue&type=script&lang=ts&"
export * from "./ChartsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ChartsPage.vue?vue&type=style&index=0&id=4da6c1b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports